"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var QuoteChoiceRequired_1 = __importDefault(require("./QuoteChoiceRequired"));
var AcceptDisabledService = (function () {
    function AcceptDisabledService(di, isPrintMode, appEvents, isTemplate, isCollaboratorPage, usingFeature) {
        var _this = this;
        this.isPrintMode = isPrintMode;
        this.appEvents = appEvents;
        this.isTemplate = isTemplate;
        this.isCollaboratorPage = isCollaboratorPage;
        this.usingFeature = usingFeature;
        this.publicProjectStatus = undefined;
        this.quoteBlocksList = undefined;
        this.acceptedThisSession = false;
        this.isDisabled = function () {
            var usingAgreementView = _this.usingFeature(FeatureFlag_1.FeatureFlag.AgreementViewBasic);
            var isPageNotLive = _this.publicProjectStatus !== null && _this.publicProjectStatus !== Types_1.ProjectStatus.Live;
            var isQuoteRequired = _this.requiresQuoteChoice();
            if (usingAgreementView) {
                if (_this.isPrintMode) {
                    return true;
                }
                if (_this.isCollaboratorPage || _this.isTemplate) {
                    return false;
                }
                return isPageNotLive || _this.acceptedThisSession || isQuoteRequired;
            }
            return (_this.isCollaboratorPage ||
                _this.isPrintMode ||
                isPageNotLive ||
                _this.acceptedThisSession ||
                isQuoteRequired ||
                _this.isTemplate);
        };
        this.requiresQuoteChoice = function () {
            var _a, _b;
            return (0, QuoteChoiceRequired_1.default)((_b = (_a = _this.quoteBlocksList) === null || _a === void 0 ? void 0 : _a.get()) !== null && _b !== void 0 ? _b : []);
        };
        this.isAgreementNavigationButtonDisabled = function () {
            var isPageDraftOrLive = _this.publicProjectStatus === Types_1.ProjectStatus.Live || _this.publicProjectStatus === Types_1.ProjectStatus.Draft;
            if (_this.isPrintMode) {
                return true;
            }
            return !isPageDraftOrLive || _this.acceptedThisSession;
        };
        this.getDisabledReason = function () {
            var _a, _b;
            if (_this.isCollaboratorPage) {
                return "This page is for internal collaboration only - use the Shareable Link to allow clients to accept";
            }
            if (_this.acceptedThisSession) {
                return "You’ve already accepted this project";
            }
            else if (_this.publicProjectStatus === Types_1.ProjectStatus.Draft) {
                return "Set your page \u201Clive\u201D and allow clients to accept";
            }
            else if (_this.publicProjectStatus === Types_1.ProjectStatus.Accepted) {
                return "Looks like this project has already been accepted.";
            }
            else if (_this.publicProjectStatus === Types_1.ProjectStatus.Declined) {
                return "This page has been Declined or Expired";
            }
            else if ((0, QuoteChoiceRequired_1.default)((_b = (_a = _this.quoteBlocksList) === null || _a === void 0 ? void 0 : _a.get()) !== null && _b !== void 0 ? _b : [])) {
                return "Please select an option in the quote to accept this Qwilr Page";
            }
            else if (_this.isTemplate) {
                return "Cannot accept a template page.";
            }
            else {
                return null;
            }
        };
        this.isAcceptedInCurrentSession = function () {
            return _this.acceptedThisSession;
        };
        if (di.has("projectStatus")) {
            this.publicProjectStatus = di.get("projectStatus");
        }
        if (di.has("quoteBlocksList")) {
            this.quoteBlocksList = di.get("quoteBlocksList");
        }
        appEvents.once("accepted", function () {
            _this.acceptedThisSession = true;
        });
    }
    return AcceptDisabledService;
}());
exports.default = AcceptDisabledService;
